<template>
    <el-dialog :visible.sync="$store.state.registerDialogState" width="700px" top="6vh" :before-close="handleClose">
        <div class="dialog-base">
            <div class="base-title">请选择注册类型</div>
        </div>
        <div class="dialog-register">
            <div class="dialog-register-item" :class="{'active':switchNum == item.formData}" v-for="(item,index) in registerData" :key="index" @click="switchForm(item.formData)"> 
                <div class="register-item-tab"><i :class="item.icon"></i></div>
                <div class="register-item-title">{{ item.title }}</div>
                <div class="register-item-desc">{{ item.desc }}</div>
            </div>
        </div>
        <register-form1 v-show="switchNum == 1"></register-form1>
        <register-form2 v-show="switchNum == 2"></register-form2>
        <register-form3 v-show="switchNum == 3"></register-form3>
    </el-dialog>
</template>

<script>
import RegisterForm1 from './register/form1.vue';
import RegisterForm2 from './register/form2.vue';
import RegisterForm3 from './register/form3.vue';
export default {
    components:{
        RegisterForm1,
        RegisterForm2,
        RegisterForm3,
    },
    watch:{
        '$store.state.registerDialogState': function (newVal) {
            if(newVal == false){
                //每次重新打开弹窗时，默认不显示用户表单
                this.switchNum = 0;
            }
        },
    },
    data() {
        return {
            switchNum:0,
            registerData:[
                {
                    icon:"el-icon-s-home",
                    title:"资源用户",
                    desc:"适用于提供资源的企业用户",
                    formData:'1'
                },{
                    icon:"el-icon-user-solid",
                    title:"个人用户",
                    desc:"适用于个人需求用户注册",
                    formData:'2'
                },{
                    icon:"el-icon-s-cooperation",
                    title:"企业用户",
                    desc:"适用于企业需求用户注册",
                    formData:'3'
                },
            ]
            
        };
    },
    methods: {
        switchForm(tab) {
            this.switchNum = tab; 
        },
        handleClose(){
            this.$store.commit('SET_REGISTER_DIALOG_STATE', false);
        },
    },
};
</script>

<style lang="scss" scoped>
.dialog-base{
    width:600px;
    height:auto;
    cursor:default;
    .base-title{
        width:100%;
        height:30px;
        line-height:30px;
        text-align:center;
        font-size:18px;
        color:#333;
        font-weight:bold;
        margin-top:10px;
    }
}
.dialog-register{
    width:600px;
    height:auto;
    margin:10px auto 10px;
    cursor:default;
    display: flex;
    justify-content: space-between;
    .dialog-register-item{
        width:32%;
        height:150px;
        border:1px solid #E5E7EB;
        border-radius:5px;
        text-align:center;
        box-sizing:border-box;
        padding:10px 10px;
        transition: transform 0.2s ease-in-out;
        .register-item-tab{
            width:50px;
            height:50px;
            margin:0 auto;
            border-radius:50%;
            color:#0066ff;
            font-size:22px;
            background-color: #dbeafe;
            display:flex;
            align-items: center;
            justify-content: center;
        }
        .register-item-title{
            font-size:15px;
            color:#333;
            margin-top:10px;
        }
        .register-item-desc{
            font-size:13px;
            color:#666;
            margin-top:10px;
        }
    }
    .dialog-register-item:hover{
        transform: translateY(-8px);
        .register-item-title{
            color:#0066ff;
        }
        .register-item-desc{
            color:#0066ff;
        }
    }
    .dialog-register-item.active{
        border:2px solid #3B82F6;
        background-color:#eff6ff;
    }
}
</style>
